import * as React from "react";
import { Admin, Resource } from "react-admin";

import dataProvider from "./components/dataProviders";


import {UserList} from "./components/Users/UsersList"
import {UserEdit} from "./components/Users/UsersEdit"
import { UserShow } from "./components/Users/UsersShow";

import { ItemList } from "./components/Items/ItemList";
import { ItemEdit } from "./components/Items/ItemEdit";

import { AdminCreate } from "./components/Admin/AdminCreate";
import { AdminEdit } from "./components/Admin/AdminEdit";
import { AdminList } from "./components/Admin/AdminList";

import { CategoryCreate } from "./components/Categories/CategoryCreate";
import { CategoryEdit } from "./components/Categories/CategoryEdit";
import { CategoryList } from "./components/Categories/CategoryList";

import { OrderEdit } from "./components/Orders/OrdersEdit";
import { OrderList } from "./components/Orders/OrdersList";

import { OperationEdit } from "./components/Operations/OperationEdit";
import { OperationList } from "./components/Operations/OperationList";



import { defaultTheme } from "react-admin";
import { createTheme } from "@material-ui/core/styles";
import GroupIcon from "@material-ui/icons/Group";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ViewAgendaIcon from "@material-ui/icons/ViewAgenda";
import CategoryIcon from "@material-ui/icons/Category";
import AirportShuttleIcon from "@material-ui/icons/AirportShuttle";

import { authProvider } from "./components/authProvider";
import GradeIcon from "@material-ui/icons/Grade";
import { CalendarList } from "./components/calendarList";
import EventIcon from "@material-ui/icons/Event";



const theme = createTheme({
    ...defaultTheme,
    sidebar: {
        width: 170, 
        closedWidth: 70, 
    },
    overrides: {
        MuiTabs:{
            root:{
                marginBottom:"2rem"
            }
        },
        MuiTableCell:{
            head:{
               fontWeight:"bold" 
            }
        },
        MuiFormControl: {
            root: {
                flexDirection: "unset",
            },
        },
        MuiFilledInput: {
            adornedEnd: {
                background: "white",
            },
            root: {
                backgroundColor: "white",
                "&:hover": {
                    backgroundColor: "white",
                },
                "&.Mui-focused": {
                    backgroundColor: "white",
                },
            },
        },
    },
});

const App = () => {
    return (
        <Admin authProvider={authProvider} theme={theme} dataProvider={dataProvider} catchAll>
            <Resource name="users" list={UserList} show={UserShow}  edit={UserEdit} icon={GroupIcon} />
            <Resource name="orders" list={OrderList} icon={AttachMoneyIcon} edit={OrderEdit} />
            <Resource name="items" list={ItemList} edit={ItemEdit} icon={ViewAgendaIcon} />
            <Resource name="categories" list={CategoryList} create={CategoryCreate} edit={CategoryEdit} icon={CategoryIcon} />
            <Resource name="operations" list={OperationList} icon={AirportShuttleIcon}  edit={OperationEdit} />
            <Resource name="Calender" list={CalendarList} icon={EventIcon} />
            <Resource name="admins" list={AdminList} icon={GradeIcon} create={AdminCreate} edit={AdminEdit} />
        </Admin>
    );
};
export default App;
